import { render } from "./AddonVIewContentsList.vue?vue&type=template&id=35279a88&scoped=true&ts=true"
import script from "./AddonVIewContentsList.vue?vue&type=script&lang=ts"
export * from "./AddonVIewContentsList.vue?vue&type=script&lang=ts"

import "./AddonVIewContentsList.vue?vue&type=style&index=0&id=35279a88&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35279a88"]])

export default __exports__